import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

import { GenericContainer } from '@components';

export const StyledGenericContainer = styled(GenericContainer)`
    ${tw`py-4 px-3 lg:py-5 lg:px-8`}
`;
